import { ReactNode } from 'react';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';

export interface NotificationState {
  message: ReactNode;
  displayType: 'default' | 'error' | 'success';
  cta?: ReactNode;
}

export interface NotificationActionTypes {
  type: string;
  message?: ReactNode;
  displayType?: 'default' | 'error' | 'success';
  cta?: ReactNode;
}
